import styles from './CartItemList.scss';

import React, { FC, useState } from 'react';

import NativeSelect from '@material-ui/core/NativeSelect';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { ContentType, LinkVariant, ProductModule } from 'src/api/contentful/contentTypes.cloverdotcom';
import { Button } from 'src/components/Button/Button';
import { useCart } from 'src/components/Cart/UseCart';
import { Grid } from 'src/components/Grid/Grid';
import { Image } from 'src/components/Image/Image';
import { ProductModal } from 'src/components/ProductModal/ProductModal';
import { TextV2 } from 'src/components/TextV2/TextV2';
import { useCMSFilteredByDcsId } from 'src/hooks/UseCMSByFilters';
import naImage from 'src/images/na.png';
import { componentKeyV2 } from 'src/utils/ComponentKeyV2';
import { CartListProps } from './CartItem';

interface CartListItemProps {
    cartListItem?: CartListProps;
}

const cartNumberList = Array.from({ length: 10 }, (v, i) => i + 1);

export const CartItemList: FC<CartListItemProps> = ({ cartListItem }) => {
    if (!cartListItem) {
      return null;
    }
    const { updateProductQuantityById } = useCart();

    const { product, removeProductById } = cartListItem || {};
    const { id, imageURL, name, quantity, totalCost } = product || {};

    const { t } = useTranslation();
    const [modalState, toggleModal] = useState(false);
    const entries = useCMSFilteredByDcsId<ProductModule>(ContentType.PRODUCT_MODULE, id);
    const productDetails = entries && entries.data;
    const cartItemTotalCost = (totalCost && quantity) ? (totalCost * quantity) : '';

    return (
      <Grid item md={12} xs={12} className={styles.cartItemCell}>
      <Image
        src={imageURL || naImage}
        className={cx(styles.cartItemCellImage, { [styles.cartItemCellImagePointer] : productDetails })}
        aria-hidden="true"
        onClick={productDetails ? () => toggleModal(true) : undefined}
      />
      <Grid className={styles.cartItemCellNumberContainer}>
        <Button
          className={styles.cartItemCellButton}
          onClick={productDetails ? () => toggleModal(true) : undefined}
        >
          {name}
        </Button>
        <NativeSelect
          className={styles.cartItemCellNumberList}
          disableUnderline
          inputProps={{ 'aria-label': `${t('cart-page.quantity')}` }}
          defaultValue={quantity}
          onChange={event => updateProductQuantityById(((id) ? id : ''), parseInt(event.currentTarget.value))}
        >
        {cartNumberList.map((quantity, index) => <option value={quantity} key={componentKeyV2(quantity, index)}>{quantity}</option>)}
        </NativeSelect>
        {removeProductById && id && <Button variant={LinkVariant.TEXT} className={styles.cartItemCellRemove} onClick={() => removeProductById(id)}>{t('remove')}</Button>}
      </Grid>
      <div className={styles.cartItemCellPriceList}>
        <TextV2
          value={`${t('cart-page.item-cost', { price: cartItemTotalCost })}`}
          className={styles.cartItemCellCost}
          tagName="div"
          variant="body"
        />
        {(quantity) && (quantity) > 1 ? (
          <TextV2
            value={`${t('cart-page.each-item-cost', { price: totalCost })}`}
            className={styles.cartItemCellEachCost}
            tagName="div"
            variant="body-small"
          />
        ) : ''}
      </div>
      {productDetails && <ProductModal closeModal={() => toggleModal(bool => !bool)} modalOpen={modalState} productDetails={productDetails} />}
    </Grid>
    );
  };

  CartItemList.displayName = 'CartItemList';
